import styled from "styled-components";

export const ThankyouWrapper = styled.div`
  background: #252525;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  background: #000000;
  max-width: 95%;
  width: 650px;
  margin: auto;
  padding: 3rem 5rem;

  .app-logo{
    width: 200px;
    margin-bottom: 2rem;
  }

  @media (max-width: 640px) {
    padding: 3rem 1.5rem;
  }
`;